import { FC } from "react";
import styled from "styled-components";

const SwatchContainer = styled.div<{ $brand?: string }>`
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin-top: 8px;

  ${({ $brand }) =>
    $brand == 'jackson' &&`
      padding-right: 20px;
    `
  }
`;

const SwatchButton = styled.button<{ $isActive: boolean; $brand: string }>`
  appearance: none;
  background: none;
  border: 1px solid ${({ $isActive }) => ($isActive ? '#191a1f' : 'rgba(25, 26, 31, 0.2)')};
  border-radius: 50%;
  cursor: pointer;
  width: 24px;
  height: 24px;
  padding: 0;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  ${({ $brand }) =>
    $brand == 'jackson' &&`
      height: 1.375rem;
      width: 1.375rem;
    `
  }  
`;

export interface SwatchVariant {
  swatchName: string;
  swatchImageUrl: string;
  variantImageUrl: string;
  productUrl: string;
}

interface ProductTileSwatchesProps {
  activeVariantIndex: number;
  brand: string;
  layout: string;
  variants: SwatchVariant[];
  onSwatchHover: (index: number) => void;
}

const ProductTileSwatches: FC<ProductTileSwatchesProps> = ({
  activeVariantIndex,
  brand,
  variants,
  onSwatchHover,
}) => (
  <SwatchContainer $brand={brand}>
    {variants.map((variant, index) => (
      <SwatchButton
        key={index}
        $brand={brand}
        $isActive={index === activeVariantIndex}
        onMouseEnter={() => onSwatchHover(index)}
      >
        <img src={variant.swatchImageUrl} alt={variant.swatchName || `Swatch ${index + 1}`} />
      </SwatchButton>
    ))}
  </SwatchContainer>
);

export default ProductTileSwatches;
